import { selectionPositioner, hasStateChanged } from '@remirror/extension-positioner';
import type { Positioner } from '@remirror/extension-positioner';
import { usePositioner } from '@remirror/react';

export const useTextSelectionPositioner = () => {
  return usePositioner<{ from: Coords; to: Coords }>((): Positioner<{ from: Coords; to: Coords }> => {
    return selectionPositioner.clone({
      hasChanged: props => hasStateChanged(props),
      getActive: ({ view, state }) => {
        const { from, to, empty } = state.selection;

        if (empty || from === to) {
          return [];
        }

        const start = Math.min(from, to);
        const end = Math.max(from, to);

        const fromCoords = view.coordsAtPos(start);
        const toCoords = view.coordsAtPos(end);

        return [{ from: fromCoords, to: toCoords }];
      },
    });
  }, []);
};

type Coords = {
  left: number;
  right: number;
  top: number;
  bottom: number;
};
